module.exports = __webpack_public_path__ + "img/rank1.586a8576.png";